import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import type { VirtuosoHandles } from "@msuite/ui/libs/virtuoso";
import { useTranslation } from "@msuite/ui/localization";
import { useQuery } from "@msuite/ui/query";
import { TimelineActivityChart } from "@msuite/ui/timeline";
import { responseHandler } from "@msuite/ui/utils";
import { TicketTypeIcon } from "@/components/cards";
import { client } from "@/hono";

/** Props Interface */
interface ProjectActivityGraphProps {
	projectId: string;
	virtuosoHandles: VirtuosoHandles;
}

export function ProjectActivityGraph({ projectId, virtuosoHandles }: ProjectActivityGraphProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Query */
	const { data } = useQuery({
		queryKey: ["project", "timeline", projectId],
		queryFn: async () => {
			const response = await client.projects[":projectId"].timeline.$get({
				param: {
					projectId,
				},
			});
			const data = await responseHandler(response);
			if (!data.success) throw new Error("Error fetching timeline");
			return data;
		},
		enabled: false,
	});

	return (
		<ContentCard
			title={t("projects.project_acitivity")}
			icon={icon("Activity")}
		>
			<TimelineActivityChart
				virtuosoHandles={virtuosoHandles}
				data={data?.assignmentsTimeline}
				getDate={(item) => item.crew.plan.date}
				renderTooltip={(items) => (
					<div className="w-[400px] v-stack">
						{items.map((item) => (
							<div
								className="h-stack text-xs"
								key={item.item.id}
							>
								<TicketTypeIcon ticketTypeId={item.item.ticket.type} />
								<p>{item.item.ticket.description}</p>
							</div>
						))}
					</div>
				)}
			/>
		</ContentCard>
	);
}
